<template>
  <div>
    <van-tabs
      v-model="active"
      line-height="2px"
      color="#45B9BC"
      sticky
      title-active-color="#45B9BC"
    >
      <van-tab title="个人注册">
        <van-cell-group class="applyForm">
          <van-field v-model="personalInfo.username" label="联系人" placeholder="请输入联系人姓名" />
          <van-field v-model="personalInfo.phoneNum" label="手机号" placeholder="请输入手机号" />
          <van-field v-model="personalInfo.codeNum" label="短信验证码" placeholder="请输入短信验证码">
            <van-button
              slot="button"
              size="small"
              class="reg__codeBtn"
              @click="personalCode"
            >{{personalInfo.btnTitle}}</van-button>
          </van-field>
          <!--省市区-->
          <van-field
            v-model="personalInfo.area"
            label="选择地区"
            placeholder="请选择省市区"
            @click="per_showPopup"
            right-icon="arrow"
          />
          <van-popup v-model="personalInfo.show" position="bottom">
            <van-area
              :area-list="personalInfo.areaList"
              @confirm="per_checkArea"
              @cancel="personalInfo.show = false"
            />
          </van-popup>
          <van-field
            v-model="personalInfo.addressDetails"
            rows="1"
            autosize
            label="详细地址"
            type="textarea"
            placeholder="请输入街道门牌"
          />
          <div class="applyForm__upload">
            <div class="applyForm__title">请上传身份证正反面</div>
            <uploadImg :Box="personalBox" :count="2" v-on:uploadImg="personalImg"></uploadImg>
          </div>
        </van-cell-group>
        <van-checkbox v-model="personalInfo.checked" checked-color="#45B9BC" icon-size="18px">
          <span class="col_999 ml_2">我已阅读并同意</span>
          <router-link :to="{path:'/tech_agreement',query:{type:1}}" class="col_45B9BC">《平台合作协议》</router-link>
        </van-checkbox>
        <div class="sureBtn__box">
          <button @click="per_submitBtn">提交申请</button>
        </div>
      </van-tab>

      <van-tab title="公司注册">
        <van-cell-group class="applyForm">
          <van-field v-model="companyInfo.companyName" label="名称" placeholder="请输入公司名称" />
          <van-field v-model="companyInfo.username" label="联系人" placeholder="请输入联系人姓名" />
          <van-field v-model="companyInfo.phoneNum" label="手机号" placeholder="请输入手机号" />
          <van-field v-model="companyInfo.codeNum" label="短信验证码" placeholder="请输入短信验证码">
            <van-button
              slot="button"
              size="small"
              class="reg__codeBtn"
              @click="com_codeBtn"
            >{{companyInfo.btnTitle}}</van-button>
          </van-field>
          <!--省市区-->
          <van-field
            v-model="companyInfo.area"
            label="选择地区"
            placeholder="请选择省市区"
            @click="com_showPopup"
            right-icon="arrow"
            disabled
          />
          <van-popup v-model="companyInfo.show" position="bottom">
            <van-area
              :area-list="companyInfo.areaList"
              @confirm="com_checkArea"
              @cancel="companyInfo.show = false"
            />
          </van-popup>
          <van-field
            v-model="companyInfo.addressDetails"
            rows="1"
            autosize
            label="详细地址"
            type="textarea"
            placeholder="请输入街道门牌"
          />
          <div class="applyForm__upload">
            <div class="applyForm__title">营业执照</div>

            <uploadImg :Box="companyBox" :count="1" v-on:uploadImg="companyImg"></uploadImg>
          </div>
        </van-cell-group>
        <van-checkbox v-model="companyInfo.checked" checked-color="#45B9BC" icon-size="18px">
          <span class="col_999 ml_2">我已阅读并同意</span>
          <router-link :to="{path:'/tech_agreement',query:{type:1}}" class="col_45B9BC">《平台合作协议》</router-link>
        </van-checkbox>
        <div class="sureBtn__box">
          <button @click="com_submitBtn">提交申请</button>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import areaList from "@/assets/js/areaList";
import uploadImg from "@/components/uploadImg";
var phoneNum_reg = /^1([38]\d|5[0-35-9]|7[3678])\d{8}$/; //手机号正则
var perList; //个人注册数组
var comList; //公司注册数组

export default {
  name: "storeApply",
  components: { uploadImg },
  data() {
    return {
      active: 0,
      // 个人注册表单信息
      personalInfo: {
        username: "", //联系人
        phoneNum: "", //手机号
        codeNum: "", //验证码
        btnTitle: "获取验证码", //获取验证码
        addressDetails: "", //详细地址
        storeName: "", //门店
        area: "", //选择地区
        show: false, //省市区弹出层
        areaList, //省市区组件
        checked: true //同意协议书-复选框
      },

      //公司注册表单信息
      companyInfo: {
        companyName: "", //公司名称
        username: "", //联系人
        phoneNum: "", //手机号
        codeNum: "", //验证码
        btnTitle: "获取验证码", //获取验证码
        addressDetails: "", //详细地址
        storeName: "", //门店
        area: "", //选择地区
        show: false, //省市区弹出层
        areaList, //省市区组件
        fileList: [
          { url: "https://img.yzcdn.cn/vant/leaf.jpg" },
          // Uploader 根据文件后缀来判断是否为图片文件
          // 如果图片 URL 中不包含类型信息，可以添加 isImage 标记来声明
          { url: "", isImage: true }
        ],
        checked: true //同意协议书-复选框
      },
      companyBox: {
        localIds: [],
        serverId: []
      },
      personalBox: {
        localIds: [],
        serverId: []
      },
      com_sessionId:0,
      sessionId:0,
      member_recommend:0
    };
  },
  created() {
    perList = this.personalInfo;
    comList = this.companyInfo;
    
    if(this.$route.query.member_id > 0){
      this.member_recommend = this.$route.query.member_id;
      console.log(this.member_recommend);
    }

  },
  updated() {
    perList = this.personalInfo;
    comList = this.companyInfo;
  },

  methods: {
    personalImg(data) {
      this.personalBox.localIds = data.localIds;
      this.personalBox.serverId = data.serverId;
      console.log(this.personalBox);
    },
    companyImg(data) {
      this.companyBox.localIds = data.localIds;
      this.companyBox.serverId = data.serverId;
      console.log(this.companyBox);
    },
    //---------个人注册表单验证---------//
    // 省市区弹出层
    per_showPopup() {
      perList.show = true;
    },
    //省市区弹出层-确认按钮
    per_checkArea(value) {
      perList.show = false;
      perList.area = value[0].name + " " + value[1].name + " " + value[2].name;
    },
    // 提交按钮
    per_submitBtn() {
      if (!perList.username) {
        this.$toast("请输入联系人姓名！");
        return false;
      }
      if (!perList.phoneNum) {
        this.$toast("请输入手机号！");
        return false;
      }
      if (!phoneNum_reg.test(perList.phoneNum)) {
        this.$toast("手机号格式不正确");
        return false;
      }
      if (!perList.codeNum) {
        this.$toast("请输入验证码！");
        return false;
      }
      if (!perList.area) {
        this.$toast("请输入地区！");
        return false;
      }
      if (!perList.addressDetails) {
        this.$toast("请输入街道门牌！");
        return false;
      }
      if (!perList.checked) {
        this.$toast("请阅读并同意《平台合作协议》");
        return false;
      }
      console.log(this.member_recommend);

      this.axios({
        url: this.api.store.store_apply,
        data: {
          apply_type: 1,
          realname: perList.username,
          mobile: perList.phoneNum,
          verifycode: perList.codeNum,
          areas: perList.area,
          address: perList.addressDetails,
          idcard_img: this.personalBox,
          sessionId: this.sessionId,
          member_recommend: this.member_recommend
        }
      }).then(res => {
        if (res.error === 0) {
          var that = this;
          if (res.status == 0) {
            that.$toast({
              type: "fail",
              message: res.message,
              duration: 1500
            });
          }
          if (res.status == 1) {
            that.$toast({
              type: "success",
              message: res.message,
              duration: 1500,
              onClose: function() {
                that.$router.push("/index");
              }
            });
          }
        }else{
          that.$toast({
              message: res.error,
              duration: 1500
          });
        }
      });
    },
    personalCode() {
      if (perList.phoneNum == "") return;
      let str = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
      if (str.test(perList.phoneNum)) {
        this.axios({
          url: this.api.member.get_code,
          data: {
            mobile: perList.phoneNum,
            temp:"store_apply"
          }
        }).then(res => {
          if (res.error === 0) {
            this.countTime();
            this.sandSuccess = true;
            this.sessionId = res.sessionId;
            this.$toast("信息已发送");
          } else {
            this.$toast(res.error);
          }
        });
      } else {
        this.$toast("手机号不正确");
      }
    },
    // 发送验证码
    countTime() {
      if (!perList.phoneNum) {
        this.$toast("请输入手机号！");
        return false;
      }
      if (!phoneNum_reg.test(perList.phoneNum)) {
        this.$toast("手机号格式不正确");
        return false;
      }
      if (!perList.disabled) {
        //倒计时
        let time = 60;
        let timer = setInterval(() => {
          if (time == 0) {
            clearInterval(timer);
            perList.disabled = false;
            perList.btnTitle = "获取验证码";
          } else {
            perList.btnTitle = time + "秒后重试";
            perList.disabled = true;
            time--;
          }
        }, 1000);
      }
    },

    //---------公司注册表单验证----------//
    com_showPopup() {
      // 省市区弹出层
      comList.show = true;
    },
    //省市区弹出层-确认按钮
    com_checkArea(value) {
      comList.show = false;
      comList.area = value[0].name + " " + value[1].name + " " + value[2].name;
    },
    // 提交按钮
    com_submitBtn() {
      if (!comList.companyName) {
        this.$toast("请输入公司名称！");
        return false;
      }
      if (!comList.username) {
        this.$toast("请输入联系人姓名！");
        return false;
      }
      if (!comList.phoneNum) {
        this.$toast("请输入手机号！");
        return false;
      }
      if (!phoneNum_reg.test(comList.phoneNum)) {
        this.$toast("手机号格式不正确");
        return false;
      }
      if (!comList.codeNum) {
        this.$toast("请输入验证码！");
        return false;
      }
      if (!comList.area) {
        this.$toast("请输入地区！");
        return false;
      }
      if (!comList.addressDetails) {
        this.$toast("请输入街道门牌！");
        return false;
      }
      if (!comList.checked) {
        this.$toast("请阅读并同意《平台合作协议》");
        return false;
      }

      console.log(this.companyBox);

      this.axios({
        url: this.api.store.company_apply,
        data: {
          apply_type: 2,
          realname: comList.username,
          mobile: comList.phoneNum,
          verifycode: comList.codeNum,
          areas: comList.area,
          address: comList.addressDetails,
          working_img: this.companyBox,
          sessionId: this.com_sessionId,
          company_name: comList.companyName,
          member_recommend: this.member_recommend
        }
      }).then(res => {
        if (res.error === 0) {
          var that = this;
          if (res.status == 0) {
            that.$toast({
              type: "fail",
              message: res.message,
              duration: 1500
            });
          }
          if (res.status == 1) {
            
            that.$toast({
              type: "success",
              message: res.message,
              duration: 1500,
              onClose: function() {
                that.$router.push("/index");
              }
            });
          }
        }else{
          that.$toast({
              message: res.error,
              duration: 1500
          });
        }
      });
    },
    // 发送验证码
    com_codeBtn() {
      if (comList.phoneNum == "") return;
      let str = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
      if (str.test(comList.phoneNum)) {
        this.axios({
          url: this.api.member.get_code,
          data: {
            mobile: comList.phoneNum,
            temp:"store_apply"
          }
        }).then(res => {
          if (res.error === 0) {
            this.com_countTime();
            this.sandSuccess = true;
            this.com_sessionId = res.sessionId;
            this.$toast("信息已发送");
          } else {
            this.$toast(res.error);
          }
        });
      } else {
        this.$toast("手机号不正确");
      }
    },
    // 发送验证码
    com_countTime() {
      if (!comList.phoneNum) {
        this.$toast("请输入手机号！");
        return false;
      }
      if (!phoneNum_reg.test(comList.phoneNum)) {
        this.$toast("手机号格式不正确");
        return false;
      }
      if (!comList.disabled) {
        //倒计时
        let time = 60;
        let timer = setInterval(() => {
          if (time == 0) {
            clearInterval(timer);
            comList.disabled = false;
            comList.btnTitle = "获取验证码";
          } else {
            comList.btnTitle = time + "秒后重试";
            comList.disabled = true;
            time--;
          }
        }, 1000);
      }
    },
  }
};
</script>

<style scoped>
.applyForm {
  margin-top: 0.35rem;
  background: #fff;
}
.applyForm .van-cell {
  align-items: center;
  -webkit-align-items: center;
  padding: 0.5rem 0.75rem;
  line-height: 1.2rem;
  font-size: 0.7rem;
  color: #333;
}
.applyForm__upload {
  padding: 0 0.75rem 0.35rem;
  color: #333;
}
.applyForm__title {
  padding: 0.5rem 0;
  font-size: 0.7rem;
  line-height: 1.2rem;
  margin-bottom: 0.25rem;
}
.van-checkbox {
  padding: 0.5rem 0.75rem;
  font-size: 0.65rem;
}
.ml_2 {
  margin-left: -0.1rem;
}
.reg__codeBtn {
  padding-left: 0;
  border: 1px solid rgba(69, 185, 188, 0.5);
  border-radius: 0.15rem;
}
.reg__codeBtn .van-button__text {
  padding-left: 0.5rem;
  color: #45b9bc;
}
.sureBtn__box {
  padding-top: 1.25rem;
}
</style>



// WEBPACK FOOTER //
// src/views/store/storeApply.vue